import { atom } from "recoil"

export const linkingRestorerState = atom<{ restorer: () => void } | undefined>({
  key: "atoms/linkingRestorerState",
  default: undefined,
})
